const META_OWNED_HOSTS = ['facebook.com', 'fb.com', 'fb.me', 'instagram.com', 'messenger.com', 'meta.com']

/** Whether a link points to a Meta property (Facebook, Instagram, ...). Meta refuses these as the link of a lead ad. */
export const isMetaOwnedUrl = (value) => {
    if (typeof value !== 'string' || !value.trim()) return false
    try {
        const text = value.trim()
        const host = new URL(/^[a-z][a-z0-9+.-]*:\/\//i.test(text) ? text : `https://${text}`).hostname.toLowerCase().replace(/\.$/, '')
        return META_OWNED_HOSTS.some((owned) => host === owned || host.endsWith(`.${owned}`))
    } catch {
        return false
    }
}

export const META_OWNED_URL_MESSAGE =
    'Use your own website. Meta does not accept a link to Facebook or Instagram for lead ads.'
